import apiFetch from '../apiFetch'

export default function (idCliente, token) {
  return apiFetch({endPoint: `Combos/getDireccionesCliente?idCliente=` + idCliente, method: 'GET', body: null, token: token})
}
